module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "half"
  }, [_vm._v("Battleground")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("From the Channel to the  Ypres Salient")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f000i-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("King Albert of the Belgians and his Queen, Elisabeth of Bavaria, played a vital part in the portrayal of Belgium to the world and in maintaining the morale of a nation that had been reduced by the end of 1914 to a faint shadow of its pre-August 1914 self. They represented Belgium’s courage and endurance in adversity. He had a physical advantage in that he was a very tall man, which made him easily recognisable in group photographs of allied commanders or political personalities. Albert, beside his constitutional role (which was substantial), was also a military commander: in September 1918 he led the attack from the sea to Ypres, commanding Army Group Flanders, against Germany’s northern flank. It was Belgian troops, for example, that finally liberated Passchendaele.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ii.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b6fe85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Halftitle.vue
// module id = 57
// module chunks = 0